export const STUDENT_PAYMENTS = '/student_payment/'
export const STUDENT_PAYMENTS_BY_STUDENT = `${STUDENT_PAYMENTS}student/` as const
export const STUDENT_PAYMENTS_PRINCIPAL = `${STUDENT_PAYMENTS}student/all` as const
